import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "../config/firebase";
import type { TargetType } from "../types";

async function call<T>(name: string, data: Record<string, unknown>): Promise<T> {
  if (!cloudFunctions) throw new Error("Content lifecycle service is unavailable.");
  return (await httpsCallable<Record<string, unknown>, T>(cloudFunctions, name)(data)).data;
}

export const removeMap = (mapId: string) => call<{ retainedUntil: string }>("removeMap", { mapId });
export const moderatePost = (targetType: TargetType, targetId: string, removed: boolean) =>
  call<{ removed: boolean; retainedUntil: string | null }>("moderatePost", { targetType, targetId, removed });
